export default "__VITE_ASSET__DIDAcCpf__"